import { LicenceAssignmentDTO, CompanyPayContextDTO } from './../models/commercialProduct.model';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CheckLicenceDTO } from '../models/checklicence.model';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})

export class LicenceService {

  constructor(private http: HttpClient) {
  }

  checkValidLicence(checkLicenceObject: CheckLicenceDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Licence/CheckLicence', checkLicenceObject).toPromise();
  }

  getAllPurchasedLicences(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Licence/GetAllPurchasedLicences/' + fk_company).toPromise();
  }

  getAllTransferredLicencesFromCompany(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Licence/GetAllTransferredLicencesFromCompany/' + fk_company).toPromise();
  }

  getAllTransferredLicencesToCompany(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Licence/GetAllTransferredLicencesToCompany/' + fk_company).toPromise();
  }

  getAllActivatedLicences(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Licence/GetAllActivatedLicences/' + fk_company).toPromise();
  }

  getCommercialProductsByCompany(fk_company: number): Promise<any> {        
    //const headers = new HttpHeaders().append('x-api-key', GlobalService.getAdministrativeApiKey());
    //return this.http.get<any>(environment.apiFullUrl + '/Licence/GetCommercialProductsByCompany/' + fk_company, { headers }).toPromise();
    return this.http.get<any>(environment.apiFullUrl + '/Licence/GetCommercialProductsByCompany/' + fk_company).toPromise();
  }

  assignLicence(licenceAssignmentDTO: LicenceAssignmentDTO): Promise<boolean> {
    return this.http.post<boolean>(environment.apiFullUrl + '/Licence/AssignLicence', licenceAssignmentDTO).toPromise();
  }

  GetPayContextByCompany(fk_company: number): Promise<any> {        
    return this.http.get<any>(environment.apiFullUrl + '/CompanyPayContext/GetPayContextByCompany/' + fk_company).toPromise();
  }

  GetNamirialPayProducts(fk_company: number): Promise<any> {        
    return this.http.get<any>(environment.apiFullUrl + '/Licence/GetNamirialPayProducts/' + fk_company).toPromise();
  }

  PayContextSave(CompanyPayContextDTO: CompanyPayContextDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/CompanyPayContext', CompanyPayContextDTO).toPromise();    
  }

  PayContextDelete(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/CompanyPayContext/' + id).toPromise();    
  }
  
  
}


